import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dateInput",
    "datePanel",
    "dateToggle",
    "reminderPanel",
    "timeInput",
    "timePanel",
    "timeToggle"
  ]

  connect() {
    this.sync()
  }

  dateChanged() {
    if (this.dateToggleTarget.checked) {
      this.setDefaultDate()
    } else {
      this.timeToggleTarget.checked = false
    }

    this.sync()
  }

  timeChanged() {
    if (this.timeToggleTarget.checked) {
      this.dateToggleTarget.checked = true
      this.setDefaultDate()
      this.setDefaultTime()
    }

    this.sync()
  }

  sync() {
    const dateEnabled = this.dateToggleTarget.checked
    const timeEnabled = dateEnabled && this.timeToggleTarget.checked

    this.datePanelTarget.classList.toggle("hidden", !dateEnabled)
    this.timePanelTarget.classList.toggle("hidden", !timeEnabled)
    this.reminderPanelTarget.classList.toggle("hidden", !timeEnabled)
    this.setDateInputDisabled(!dateEnabled)
    this.setTimeInputDisabled(!timeEnabled)
  }

  setDateInputDisabled(disabled) {
    this.dateInputTarget.disabled = disabled

    const visibleInput = this.dateInputTarget._flatpickr?.altInput
    if (visibleInput) visibleInput.disabled = disabled
  }

  setTimeInputDisabled(disabled) {
    this.timeInputTarget.disabled = disabled

    const visibleInput = this.timeInputTarget._flatpickr?.altInput
    if (visibleInput) visibleInput.disabled = disabled
  }

  setDefaultDate() {
    if (this.dateInputTarget.value) return

    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, "0")
    const day = String(today.getDate()).padStart(2, "0")
    const value = `${year}-${month}-${day}`

    if (this.dateInputTarget._flatpickr) {
      this.dateInputTarget._flatpickr.setDate(value, true)
    } else {
      this.dateInputTarget.value = value
    }
  }

  setDefaultTime() {
    if (this.timeInputTarget.value) return

    const time = new Date()
    time.setMinutes(Math.ceil(time.getMinutes() / 5) * 5, 0, 0)
    const value = `${String(time.getHours()).padStart(2, "0")}:${String(time.getMinutes()).padStart(2, "0")}`

    if (this.timeInputTarget._flatpickr) {
      this.timeInputTarget._flatpickr.setDate(value, true, "H:i")
    } else {
      this.timeInputTarget.value = value
    }
  }
}
